module.exports = __webpack_public_path__ + "static/01-9a58bef0d4c72cb1563687f71c5c17eb.jpg";